<template>
    <v-card flat tile color="secondary" class="pb-1">
        <RowHeading
            :headline="$t('vvtProcessEditor.purposeOfProcessing.headline')"
            :button-text="$t('vvtProcessEditor.purposeOfProcessing.add')"
            :disabled="!canEdit"
            @click:add="addRow"
        />
        <div v-if="purposesOfProcessing && purposesOfProcessing.length" class="pl-6">
            <PurposeItem
                v-for="(purposeOfProcessing, i) in purposesOfProcessing"
                :create="create"
                :key="purposeOfProcessing.id || purposeOfProcessing.clientId"
                :rowId="purposeOfProcessing.id || purposeOfProcessing.clientId"
                :formScope="formScope"
                :i="i"
                :lastIndex="purposesOfProcessing.length - 1"
                :countryCode="countryCode"
                :currentUiLanguage="currentUiLanguage"
                :isCollapsed="collapseStates[i]"
                :canEdit="canEdit"
                @collapse="onCollapse($event)"
                @collapseAll="onCollapseAll()"
                @help-mode="$emit('help-mode', $event)"
            />
        </div>
        <div v-else class="ma-3">
            <v-btn
                :disabled="!canEdit"
                @click="addRow"
                color="success"
                x-large
                block
                text
                outlined
                class="btn--justify-content-start text-transform--none"><v-icon left>mdi-plus</v-icon>{{ $t('vvtProcessEditor.purposeOfProcessing.addHint') }}
            </v-btn>
        </div>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import RowHeading from '@/components/vvt/ProcessEditor/Row/Heading.vue';
import PurposeItem from './PurposeItem.vue';
export default {
    name: 'PurposeOfProcessing',
    components: {
        RowHeading,
        PurposeItem,
    },
    props: {
        formScope: {
            type: String,
            default: null,
        },
        create: {
            type: Boolean,
            default: false,
        },
        countryCode: {
            type: String,
            default: null,
        },
        currentUiLanguage: {
            type: String,
            default: null,
        },
    },
    i18n: {
        messages: {
            en: require('@/locales/vvt/ProcessEditor/en.json'),
            de: require('@/locales/vvt/ProcessEditor/de.json'),
        },
    },
    data() {
        return {
            collapseStates: [],
        };
    },
    computed: {
        ...mapGetters({
            get: 'processingActivityModel/getProperty'
        }),
        purposesOfProcessing() {
            return this.get('purposeOfProcessing');
        },
        canEdit () {
            return this.get('canEdit');
        },
    },
    methods: {
        addRow() {
            this.$store
                .dispatch('processingActivityModel/addPurposeOfProcessing')
                .then(() => {
                    this.collapseAll();
                    this.$set(this.collapseStates, 0, false);
                });
        },
        onCollapse(event) {
            if (event.type === 'hide') {
                this.$set(this.collapseStates, event.index, true);
            } else {
                this.$set(this.collapseStates, event.index, false);
            }
        },
        onCollapseAll() {
            this.collapseAll();
        },
        collapseAll() {
            for (var i = 0, len = this.purposesOfProcessing.length; i < len; i++) {
                this.$set(this.collapseStates, i, true);
            }
        },
    },
    created() {
        this.collapseAll();
    },
};
</script>
